import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'app-support-boolean-value',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './support-boolean-value.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './support-boolean-value.component.scss',
})
export class SupportBooleanValueComponent {
  @Input({ required: true })
  value!: boolean
}
